"use client"
import styled from "@emotion/styled"
import { SlimStockDto } from "api"
import { GetPageQuery } from "apollo"
import {
  BlockRenderer,
  Container,
  CustomBreadcrumbs,
  ImageTextBlock,
  StickyButton,
  TopBanner,
} from "ui"
import { Culture, extractProperty, findProperty, getBreadCrumbs } from "utils"
import HeroWrapper from "../Homepage/HeroWrapper"

const StyledTopDiv = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 98px;
  }
`

type Props = {
  data: GetPageQuery
  culture: Culture
  locale: string
  messages: {
    scrollDown: string
    learnMore: string
    change?: string
    lastUpdate?: string
    cents?: string
    StockRate?: string
    baseRate?: string
  }
  stockBanner?: SlimStockDto
  page?: string
  companyName?: string
  hideBreadCrumbs?: boolean
}

function EnvironmentalProtection({
  data,
  culture,
  locale,
  messages,
  stockBanner,
  page,
  hideBreadCrumbs,
  companyName,
}: Props) {
  const { selfObject, parents } = getBreadCrumbs(data, locale)
  const components = {
    topBanner: TopBanner,
    imageTextBlock: ImageTextBlock,
    stickyButton: StickyButton,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []

  return (
    <>
      {!hideBreadCrumbs ? (
        <Container>
          <CustomBreadcrumbs current={selfObject} parents={parents} />
        </Container>
      ) : (
        <StyledTopDiv></StyledTopDiv>
      )}
      {
        <HeroWrapper>
          {blocks?.map((block: any, index: number) => {
            let additionalProps = {}
            if (block.blockType === "topBanner") {
              additionalProps = { videoHeight: "272px", imageHeight: "272px" }
            } else {
              return null
            }
            return (
              <BlockRenderer
                key={index}
                blockType={block.blockType}
                blockData={block}
                components={components}
                culture={culture}
                locale={locale}
                props={additionalProps}
              />
            )
          })}
        </HeroWrapper>
      }
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "imageTextBlock") {
          additionalProps = {
            stockBanner: { stockBanner },
            change: messages.change,
            lastUpdate: messages.lastUpdate,
            cents: messages.cents,
            StockRate: messages.StockRate,
            baseRate: messages.baseRate,
            page: page,
          }
        } else if (block.blockType === "topBanner") {
          return null
        } else if (block.blockType === "stickyButton") {
          const showButton = extractProperty(block, "showStickyButton")
          if (showButton) {
            const link = extractProperty(block, "buttonUrl")?.[0]?.name
            additionalProps = {
              companyName,
              link,
              locale,
            }
          } else {
            return null
          }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            culture={culture}
            locale={locale}
            props={additionalProps}
          />
        )
      })}
    </>
  )
}

export default EnvironmentalProtection
